
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen((o) => !o);
  const handleClose = () => setOpen(false);

  return (
    <nav className="navbar">
      <button className="burger" aria-label="Ouvrir le menu" onClick={handleToggle}>
        <span className="burger-bar" />
        <span className="burger-bar" />
        <span className="burger-bar" />
      </button>
      <ul className={open ? "open" : ""}>
        <li>
          <NavLink to="/" end onClick={handleClose}>ACCUEIL</NavLink>
        </li>
        <li>
          <NavLink to="/about" onClick={handleClose}>QUI SOMMES-NOUS ?</NavLink>
        </li>
        <li>
          <NavLink to="/services" onClick={handleClose}>SERVICES</NavLink>
        </li>
        <li>
          <NavLink to="/solutions" onClick={handleClose}>SOLUTIONS</NavLink>
        </li>
        <li>
          <NavLink to="/partenaires" onClick={handleClose}>PARTENAIRES</NavLink>
        </li>
        <li>
          <NavLink to="/careers" onClick={handleClose}>CARRIÈRES</NavLink>
        </li>
        <li>
          <NavLink to="/contact" onClick={handleClose}>CONTACT</NavLink>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
